/** @format */

import { Component, Input } from '@angular/core';

import { Cta } from '@category/data-access';
import { TaggingService } from '@shared/data-access/services';

@Component({
	selector: 'clp-cta',
	templateUrl: './cta.component.html',
	styleUrl: './cta.component.scss',
	standalone: false
})
export class CtaComponent {
	@Input() data: Cta;
	@Input() altText: string;
	@Input() tagSectionNum: string;
	@Input() widgetTypeTag: string;
	@Input() ctaIndex: number;
	@Input() parentIndex: number;
	@Input() ctaType: string;
	@Input() chevron = false;
	style: string;

	constructor(private taggingService: TaggingService) {}

	createTag(ctaText: string) {
		return this.taggingService.createTag(
			this.tagSectionNum,
			this.widgetTypeTag,
			this.parentIndex,
			this.ctaIndex,
			ctaText,
			this.altText
		);
	}
}
